<template>
    <form class="ui form detailed_form half transition transition hidden"
        @keypress.enter="$bus.$emit(eventbus.update_core_waybill.name)">
        <DetailedFormItem
            v-for="(field_name, index) in ['original_number', 'tracking_number']"
            :key="field_name+'detailed_form_item'"
            :core_waybill="core_waybill"
            :field_name="field_name"
        >
        </DetailedFormItem>

        <div class="ui segment full green">
            <div class="ui header">
                {{ $t('models.attributes.core_waybills.sender') }}
            </div>
            <DetailedFormItem
                v-for="(field_name, index) in ['sender_company_name','sender_name','sender_zip_code','sender_address','sender_phone','sender_email','sender_fax']"
                :key="field_name+'detailed_form_item'"
                :core_waybill="core_waybill"
                :field_name="field_name"
            >
            </DetailedFormItem>
        </div>

        <div class="ui segment full blue">
            <div class="ui header">
                {{ $t('models.attributes.core_waybills.consignee') }}
            </div>
            <DetailedFormItem
                v-for="(field_name, index) in ['consignee_company_name','consignee_name','consignee_zip_code','consignee_address','consignee_phone','consignee_email','consignee_fax']"
                :key="field_name+'detailed_form_item'"
                :core_waybill="core_waybill"
                :field_name="field_name"
            >
            </DetailedFormItem>
        </div>

        <div class="ui segment full orange">
            <div class="ui header">
                CVS
            </div>
            <DetailedFormItem
                v-for="(field_name, index) in ['cvs_store_number','cvs_store_name','cvs_store_address','cvs_store_phone']"
                :key="field_name+'detailed_form_item'"
                :core_waybill="core_waybill"
                :field_name="field_name"
            >
            </DetailedFormItem>
        </div>

        <div class="field"></div>
        <div class="field"></div>

        <DetailedFormItem
            v-for="(field_name, index) in ['shipping_period','shipping_note']"
            :key="field_name+'detailed_form_item'"
            :core_waybill="core_waybill"
            :field_name="field_name"
        >
        </DetailedFormItem>


        <!-- 配送日期  -->
        <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.shipping_date") }}
            </label>

            <el-date-picker
                v-if="is_can_update_field('shipping_date')"
                v-model="core_waybill.shipping_date"
                :format="'yyyy-MM-dd'"
                type="date"
                style="width:100%;"
                :placeholder="$t('ui.el.datepicker.selectDateTime')">
            </el-date-picker>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{ core_waybill.shipping_date || $t('ui.general.no_data') }}
            </div>
        </div>

        <!-- <DetailedFormItem
            v-for="(field_name, index) in ['charge']"
            :key="field_name+'detailed_form_item'"
            :core_waybill="core_waybill"
            :field_name="field_name"
            :input_type="'number'"
        >
        </DetailedFormItem> -->

        <!-- <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.is_charged") }}
            </label>

            <div class="ui slider checkbox" v-if="is_can_update_field('is_charged')">
                <input type="checkbox" id="is_charged" v-model="core_waybill.is_charged">
                <label class="pointer" for="is_charged">
                    {{
                        (core_waybill.is_charged)
                            ? $t("models.attributes.core_waybills.paid")
                            : $t("models.attributes.core_waybills.no_paid")
                    }}
                </label>
            </div>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{
                    (core_waybill.is_charged)
                        ? $t("models.attributes.core_waybills.paid")
                        : $t("models.attributes.core_waybills.no_paid")
                }}
            </div>

        </div> -->

        <div class="ui divider"></div>
        <!-- 付款方式 -->
        <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.payment_type") }}
            </label>
            <select
                class="ui dropdown"
                v-if="is_can_update_field('payment_type')"
                v-dropdown
                v-model="core_waybill.payment_type">
                <option value="">{{ $t('ui.general.please_select') }}</option>
                <option v-for="payment_type in core_waybill_payment_types"
                    :value="payment_type.value">
                    {{ payment_type.name }}
                </option>
            </select>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{ core_waybill.payment_type || "無選定" }}
            </div>
        </div>

        <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.is_collected") }}
            </label>
            <div class="ui slider checkbox" v-if="is_can_update_field('is_collected')">
                <input type="checkbox" id="is_collected" v-model="core_waybill.is_collected">
                <label class="pointer" for="is_collected">
                    {{
                        (core_waybill.is_collected)
                            ? $t("models.attributes.core_waybills.paid")
                            : $t("models.attributes.core_waybills.no_paid")
                    }}
                </label>
            </div>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{
                    (core_waybill.is_collected)
                        ? $t("models.attributes.core_waybills.paid")
                        : $t("models.attributes.core_waybills.no_paid")
                }}
            </div>
        </div>

        <DetailedFormItem
            v-for="(field_name, index) in [
                'collection',
                'collection_fee',
                'simplified_declaration_form_fee',
                'declaration_form_fee',
                'declaration_form_extra_fee',
                'tax',
                'price',
                'insurance',
                'material_fee',
                'consignee_tax_point',
                'sender_tax_point',
                'warehouse_fee',
                'fuel_surcharge',
                'value_added_service_fee',
                'overlength_fee',
                'overweight_fee',
                'extra_fee',
            ]"
            :key="field_name+'detailed_form_item'"
            :core_waybill="core_waybill"
            :field_name="field_name"
            :input_type="'number'"
        >
        </DetailedFormItem>

        <div class="ui divider"></div>

        <!-- <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.receipt_file_url") }}
                <i v-if="is_lock_field('receipt_file_url')" class="red lock icon"></i>
            </label>
            <input type="text"
                v-bind:readonly="is_lock_field('receipt_file_url')"
                v-model="core_waybill.receipt_file_url">
            </div> -->


        <DetailedFormItem
            v-for="(field_name, index) in ['station_code','temperature','flight_number','goods_name']"
            :key="field_name+'detailed_form_item'"
            :core_waybill="core_waybill"
            :field_name="field_name"
        >
        </DetailedFormItem>

        <DetailedFormItem
            v-for="(field_name, index) in ['weight_in_kilo','declared_value']"
            :key="field_name+'detailed_form_item'"
            :core_waybill="core_waybill"
            :field_name="field_name"
            :input_type="'number'"
        >
        </DetailedFormItem>

        <div class="field" style="float: left;" v-if="is_show_receipt_file">
            <label>
                {{ $t("models.attributes.core_waybills.receipt_file") }}
            </label>
            <FormFileUploader
                :is_can_update_field="is_can_update_field('receipt_file_url')"
                :core_waybill="core_waybill"
                :eventbus="eventbus"
            ></FormFileUploader>
        </div>

        <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.note") }}
            </label>

            <textarea
                v-if="is_can_update_field('note')"
                v-model="core_waybill.note"
                >
            </textarea>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{ core_waybill.note || $t('ui.general.no_data') }}
            </div>

        </div>
        <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.note_2") }}
            </label>

            <textarea
                v-if="is_can_update_field('note_2')"
                v-model="core_waybill.note_2"
                >
            </textarea>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{ core_waybill.note_2 || $t('ui.general.no_data') }}
            </div>

        </div>
        <div class="field">
            <label>
                {{ $t("models.attributes.core_waybills.note_3") }}
            </label>

            <textarea
                v-if="is_can_update_field('note_3')"
                v-model="core_waybill.note_3"
                >
            </textarea>
            <div
                v-else
                class="ui message" style="margin: 0; padding: 10px 12px;">
                {{ core_waybill.note_3 || $t('ui.general.no_data') }}
            </div>
        </div>
        <div class="field">
            <div v-for="(field_name, index) in ['goods_file_url','goods_file_url_3']"
                :key="field_name+'simple_form_item'"
                style="padding: 4px 0px;">
                <label>
                    {{ $t("models.attributes.core_waybills."+field_name) }}
                </label>
                <img v-if="core_waybill[field_name]"
                    :src="core_waybill[field_name]"
                    style="max-width:100%;"
                />
                <div
                    v-else
                    class="ui message" style="margin: 0; padding: 10px 12px;">
                    <!-- 無上傳圖片 -->
                    {{ $t('ui.pages.core_waybills.no_upload_any_picture') }}
                </div>
            </div>
        </div>
        <div class="field">
            <div v-for="(field_name, index) in ['goods_file_url_2']"
                :key="field_name+'simple_form_item'"
                style="padding: 4px 0px;">
                <label>
                    {{ $t("models.attributes.core_waybills."+field_name) }}
                </label>
                <img v-if="core_waybill[field_name]"
                    :src="core_waybill[field_name]"
                    style="max-width:100%;"
                />
                <div
                    v-else
                    class="ui message" style="margin: 0; padding: 10px 12px;">
                    <!-- 無上傳圖片 -->
                    {{ $t('ui.pages.core_waybills.no_upload_any_picture') }}
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import DetailedFormItem from "./detailed_form_item.vue"
import FormFileUploader from "./form_file_uploader.vue"

export default {
    props: {
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
        core_waybill: {
            default: {},
            type: Object
        },
        is_show_receipt_file: {
            default: false,
            type: Boolean
        },
        is_can_update: {
            default: false,
            type: Boolean
        },
        can_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        cant_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        focus_field_field_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        this.core_waybill.is_charged = false
    },
    computed: {
        core_waybill_payment_types() {
            return this.$store.state.provider.tool_core_waybill_module.core_waybill_payment_types
        },
    },
    methods: {
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return this.$parent.is_can_update_field(field_name)
        },
    },
    components: {
        DetailedFormItem,
        FormFileUploader,
    },
}
</script>

<style>
.el-input--prefix .el-input__inner{
    padding-left: 30px !important;
}
</style>
<style scoped lang="scss">
    @import "./.assets/stylesheets/detailed_form.scss";

    .ui.slider.checkbox input:checked~.box:before,
    .ui.slider.checkbox input:checked~label:before {
        background-color: #2185d0 !important;
    }
</style>
